import type { ReactElement, ReactNode } from 'react';

import { MockAuthProvider } from './mock/MockAuthProvider';
import { RealAuthProvider } from './real/RealAuthProvider';
import type { AuthMode } from './types';

interface AuthProviderProps {
  mode: AuthMode;
  children: ReactNode;
}

/**
 * Factory that picks the concrete provider.
 *
 * Mock is permitted in dev server and in dev-mode builds (`pnpm build:dev`).
 * A real production build that somehow reaches this function with
 * `mode === 'mock'` will hard-throw. vite.config.ts additionally refuses to
 * build with VITE_AUTH_MODE !== 'real' in production, so this is belt + suspenders.
 */
export function AuthProvider({ mode, children }: AuthProviderProps): ReactElement {
  if (mode === 'mock') {
    if (import.meta.env.MODE === 'production') {
      throw new Error(
        '[new-ptv2] Refusing to mount MockAuthProvider in a production build. See PTV2-910.',
      );
    }
    return <MockAuthProvider>{children}</MockAuthProvider>;
  }
  return <RealAuthProvider>{children}</RealAuthProvider>;
}
